import { Controller } from "@hotwired/stimulus"

// Modal Trigger Controller
// Triggers the global modal singleton with URL and title
//
// Usage:
// <button data-controller="modal-trigger"
//         data-modal-trigger-url-value="/path/to/content"
//         data-modal-trigger-title-value="Modal Title"
//         data-action="click->modal-trigger#open">
//
// Features:
// - Clean separation of concerns
// - No inline JavaScript
// - Reusable pattern
export default class extends Controller {
  static values = {
    url: String,
    title: String
  }

  open(event) {
    event.preventDefault()

    const modal = document.getElementById("global-modal")
    if (!modal) {
      console.error("Global modal not found")
      return
    }

    // Get the modal controller instance
    const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal")
    if (!modalController) {
      console.error("Modal controller not found")
      return
    }

    // Set values and open
    modalController.urlValue = this.urlValue
    modalController.titleValue = this.titleValue
    modalController.open(event)
  }
}
